import React from "react";

type BaseButtonProps = React.DetailedHTMLProps<React.ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement>;

interface MightierButtonProps extends Omit<BaseButtonProps, "disabled"> {
  /** what style? */
  variant?: "primary" | "disabled";
}

export const MightierButton = React.memo<MightierButtonProps>((props) => {
  const { variant = "primary", className: classNameFromProps, ...rest } = props;
  const variantClassName = variant === "disabled" ? "bg-grey" : "bg-blue";
  return (
    <button
      disabled={variant === "disabled"}
      className={`${variantClassName} rounded-full px-8 py-4 font-semibold text-white shadow-button focus:shadow-focus-glow ${classNameFromProps ?? ""}`}
      {...rest}
    >
      {props.children}
    </button>
  );
});

MightierButton.displayName = "MightierButton";
